import { apiClient } from '~/api/client'
import { useSettingsStore } from '~/stores/settings'
import { removeBrowserPushSubscription } from '~/utils/setup-notifications'

/** Call before clearing the JWT: disables the server row, unsubscribes the browser, clears persisted prefs. */
export const clearPushSubscriptionForCurrentSession = async (): Promise<void> => {
  const { pushSubscriptionEndpoint, patchSettings } = useSettingsStore.getState()

  if (pushSubscriptionEndpoint)
    try {
      await apiClient.POST('/push/toggle-subscription', {
        body: { endpoint: pushSubscriptionEndpoint, enabled: false },
      })
    } catch (error) {
      console.error({ message: 'Failed to disable push subscription on logout', error })
    }

  await removeBrowserPushSubscription()

  patchSettings({
    pushNotificationsEnabled: false,
    pushSubscriptionEndpoint: undefined,
  })
}
